<div class="animated fadeInRight">
    <!-- MENU DE TITULOS -->
    <app-lfsa-card-v2
      [titulo]      = "DAT_TITULOS.titulo"
      [modulo]      = "GLOBAL_TITULOS.modulo"
      [tituloCard]  = "DAT_TITULOS.tituloCardList"
      [innTemplate] = "enviarTemplateEdit"
      [innTemplateButton]="innTemplateButton">
    </app-lfsa-card-v2>
    <!-- MENU DE TITULOS -->
  
    <!-- OPCIONES BOTONES IZQUIERDO -->
    <ng-template #innTemplateButton>
      <div class="col-md-6 mb-2">
        <div class="pagetitle">
          <div class="btn-group-justified btn-group" style="float: right;">
           <!--  <button (click)="nuevo()" class="btn btn-primary"> <i aria-hidden="true" class="fa fa-plus"></i> Nuevo Convoy </button> -->
          </div>
        </div>
      </div>
    </ng-template>
    <!-- OPCIONES BOTONES IZQUIERDO -->
  
    <ng-template #enviarTemplateEdit>
        <!-- GRILLA -->
        <div class="col-md-12">
            <div class="col-md-6">
                <label for="cmbEstados">Filtrar Convoy por Estado</label>
                <select [(ngModel)]="filterSelected" (ngModelChange)="onChangeFiltros($event)" class="form-control btn-outline-success" name="cmbEstados" id="cmbEstados">
                    <option value="CONVOY_PLANIFICADO">Convoy Planificados</option>
                    <option value="CONVOY_CERRADO">Convoy Cerrados</option> 
                   <!--  <option value=" ">Planificados y Cerrados (esto puede tardar un poco)</option> -->
                </select>
            </div>
            <br/>
            <div class="form-group col-md-12">
                <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter " (keyup)="onQuickFilterChanged() " #quickFilter />
            </div>
            <br>
            <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
            <ag-grid-angular #agGrid (gridReady)="onGridReady($event)"  
                                [id]    ="DAT_AG_GRID.id"  [class] ="DAT_AG_GRID.class"  [ngStyle]="DAT_AG_GRID.style" 
                                [rowData]="rowData" 
                                [columnDefs]="columnDefs"
                                [pagination]="DAT_AG_GRID.pagination" 
                                [paginationPageSize]="DAT_AG_GRID.pagina"
                                [allowContextMenuWithControlKey]="true"
                                [rowHeight]="DAT_AG_GRID.rowHeight"
                                [frameworkComponents]="frameworkComponents" >
            </ag-grid-angular>
        </div>
        <!-- GRILLA [rowSelection]="rowSelectionPedidos"-->
    </ng-template>
  </div>
  
    <!-- MODAL -->
    <app-lfsa-modal [innTemplate] = "abrirModal" [classModal] = "'modal-dialog modal-lg'" [idButton]="'abrirModal'" 
        [idOpen]="'Modal'" [idClose] = "'cerrarModal'" [titulo] = "'Visualización del Convoy'">
    </app-lfsa-modal>
  
    <ng-template #abrirModal>
        <div class="container-fluid">
            <form [formGroup]="formulario" mat-dialog-content class="col-md-12" >
                <div class="row">
                    <div class="col-2">
                        <label class="form-label mb-1"><b>ID Convoy</b></label>
                        <input id="idConvoy" type="number" class="form-control form-control-sm" formControlName="idConvoy" readonly />
                    </div>
                    <div class="col">
                        <label class="form-label mb-1"><b>Grupo de Convoy</b></label>
                        <input id="grupo" type="text" class="form-control form-control-sm" formControlName="grupo" readonly />
                    </div>
                    <div class="col-3">
                        <label class="form-label mb-1"><b>Fecha y Hora Salida</b></label>
                        <input id="fechaSalida" type="text" class="form-control form-control-sm" formControlName="fechaSalida" readonly />
                    </div>
                    <div class="col-3">
                        <label class="form-label mb-1"><b>Creado Por</b></label>
                        <input id="creadoPor" type="text" class="form-control form-control-sm" formControlName="creadoPor" readonly />
                    </div>
                    <div class="col-12 mt-3">
                        <app-lfsa-input formControlName="observacion" [label]="'* Detalles u otras observaciones del Convoy'" [id]="'observacion'" 
                            [control]="formulario.get('observacion')" [placeholder]="'Observaciones'" [isReadOnly]="true"
                            class="form-control-sm" [type]="'text'" class="form-control-sm" >
                        </app-lfsa-input>                    
                    </div>
                </div>  
            </form>
            <br>
            <h5>Detalle de viajes asignados </h5>
            <!--TABLA CARGA -->
            <div class="row my-4 border rounded">
                <div class="mb-3 bg-body-secondary text-center" *ngIf="listAsignaciones?.length == 0"> Sin detalles </div>
                <div class="col-12" *ngIf="listAsignaciones?.length > 0">
                    <div class="table-responsive">
                        <table class="table table-sm table-striped table-hover align-middle mb-0" style="font-size: 0.85rem;">
                            <thead class="table-light">
                                <tr>
                                    <th class="text-nowrap">Viaje</th>
                                    <th>Chofer</th>
                                    <th>Proveedor</th>
                                    <th class="text-nowrap">Placa</th>
                                    <th class="text-nowrap">Furgón</th>
                                    <th class="text-nowrap">Rol</th>
                                    <th class="text-end text-nowrap">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of listAsignaciones; index as i">
                                    <td class="text-nowrap fw-semibold">#{{ item.viajeId }}</td>
                                    <td>{{ item.choferNombre || '-' }}</td>
                                    <td>{{ item.nombreProveedor || '-' }}</td>
                                    <td class="text-nowrap">{{ item.placa || '-' }}</td>
                                    <td class="text-nowrap">{{ item.furgon || '-' }}</td>
                                    <td class="text-nowrap">
                                        <span class="badge bg-success" *ngIf="item.esLider; else noLider">Líder</span>
                                        <ng-template #noLider><span class="badge bg-secondary">Normal</span></ng-template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        
        </div>
    </ng-template> 
    <!-- END MODAL --> 
